import axios from 'axios';
import store from '@/store';

const apiBaseUrl =
  process.env.VUE_APP_NODE_ENV === 'development'
    ? process.env.VUE_APP_LOCAL_BASE_URL
    : process.env.VUE_APP_BASE_URL;

export default ({ loadingText = '', trackProgress = false } = {}) => {
  const instance = axios.create({
    baseURL: apiBaseUrl,
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${store.state.authentication.token}`,
      locale: 'en',
    },
  });

  /* ----------------------------------------
     REQUEST INTERCEPTOR
  ----------------------------------------- */
  instance.interceptors.request.use(
    (config) => {
      store.commit('loader/INCREMENT_PENDING_REQUESTS');

      if (loadingText) {
        store.commit('loader/SET_LOADING_TEXT', loadingText);
      }

      /* 🔥 ADD PAGE ROUTE HEADER HERE */
      const currentPage = window.location.pathname.replace("/", "");
      config.headers["x-page-route"] = currentPage || "403";

      /* Existing progress tracking logic */
      if (trackProgress) {
        store.commit('loader/SET_PROGRESS', 0);

        config.onUploadProgress = (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 50) / progressEvent.total
            );
            store.commit('loader/SET_PROGRESS', percentCompleted);
          }
        };

        config.onDownloadProgress = (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              50 + (progressEvent.loaded * 50) / progressEvent.total
            );
            store.commit('loader/SET_PROGRESS', percentCompleted);
          }
        };
      }

      return config;
    },
    (error) => {
      store.commit('loader/DECREMENT_PENDING_REQUESTS');
      return Promise.reject(error);
    }
  );

  /* ----------------------------------------
     RESPONSE INTERCEPTOR
  ----------------------------------------- */
  instance.interceptors.response.use(
    (response) => {
      if (trackProgress) {
        store.commit('loader/SET_PROGRESS', 100);
      }

      store.commit('loader/DECREMENT_PENDING_REQUESTS');
      return response;
    },
    (error) => {
      store.commit('loader/DECREMENT_PENDING_REQUESTS');

      /* 🔥 AUTO-REDIRECT WHEN BACKEND RETURNS 403 */
      if (error.response && error.response.status === 403) {
        window.location.href = "/403";
      }

      return Promise.reject(error);
    }
  );

  return instance;
};
